import { ContainerModule } from "inversify";
import * as Api from "@/app/interaction/api";
import * as SerializationApi from '@/app/state-serialization/api';
import GalleryComponent from "./gallery-component.vue";
import { GalleryStateProtobufSerializer } from "./gallery-state-protobuf-serializer";
import { IncludeGalleryHandler } from './include-gallery-handler';

export const galleryFactoryModule = new ContainerModule(bind => {
  bind<Api.InteractiveComponentPlugin>(Api.InteractiveComponentPluginSymbol)
    .toConstantValue(GalleryComponent)
    .whenTargetNamed("gallery");

  bind<Api.IncludeComponentsHandlerInterface>(Api.IncludeComponentsHandlerSymbol).to(IncludeGalleryHandler);
  bind(SerializationApi.StateSerializationPluginSymbol).to(GalleryStateProtobufSerializer)
});
